import App from './core/app-core';
import { sitePageModuleLoaders } from './module-loaders';

const app = new App(sitePageModuleLoaders);

window.uEdit = app;

export default app;
